import { useOrganizationInitStatus } from '@auth/entities/organization-init';
import { hasRole, role, useAuthData } from '@auth/features/auth';

// Mirror of legacy `shouldShowInitButton`: the Initialize action is visible
// only to system-role users whose org is not yet fully initialized (any of
// the four core entities missing). Returns the status too so the dialog can
// list the missing items without refetching.
export const useShouldShowInit = () => {
  const { data: authData } = useAuthData();
  const isSystem = hasRole(authData?.user?.roles ?? [], role.system);
  const { data: status } = useOrganizationInitStatus(isSystem);

  const shouldShow =
    isSystem &&
    status != null &&
    !status.isInitialized &&
    (!status.hasLayoutTemplate ||
      !status.hasCustomer ||
      !status.hasProduct ||
      !status.hasItinerary);

  return { shouldShow, status };
};
